import { handleActions } from 'redux-actions';
import {
  RECAPTCHA_EXECUTE,
  RECAPTCHA_SKIP,
  RECAPTCHA_SET_TOKEN,
  RECAPTCHA_TOKEN_EXPIRED,
} from '../constants';

const init = {
  token: null,
  timestamp: null,
  execute: false,
  skip: false,
};

export default handleActions(
  {
    [RECAPTCHA_EXECUTE]: state => {
      return { ...state, execute: true, skip: false };
    },
    [RECAPTCHA_SKIP]: state => {
      return { ...state, execute: false, skip: true };
    },
    [RECAPTCHA_SET_TOKEN]: (state, { payload: { token } = {} }) => {
      return {
        ...state,
        token,
        timestamp: Date.now(),
        execute: false,
        skip: false,
      };
    },
    [RECAPTCHA_TOKEN_EXPIRED]: state => {
      return { ...state, token: null, timestamp: null };
    },
  },
  init,
);
